
import { Box } from "@chakra-ui/react";

export default function LogoSvg({ color1 = '#000000' , color2 = '#6ABBFC', hasBottom = true}) {
  const bottom = `
    <path class="color1" d="M378.57,138.05H34.07c-9.54,0-17.92,6.32-20.55,15.48l-4.16,14.48h344.5c9.54,0,17.92-6.32,20.55-15.48
      L378.57,138.05z"/>
    <g>
      <path class="color2" d="M278.95,141.84l-4.03,22.62h-5.59l-5.79-10.54l-1.87,10.54h-6.62l4.03-22.62h5.59l5.79,10.54l1.87-10.54
        H278.95z"/>
      <path class="color2" d="M289.32,147.6l-0.46,2.65h8.52l-0.98,5.49h-8.55l-0.52,2.97h10.11l-1.04,5.75h-16.76l4.03-22.62h16.39
        l-1.04,5.75H289.32z"/>
      <path class="color2" d="M337.01,141.84l-10.48,22.62h-7.29l-1.15-11.93l-5.53,11.93h-7.29l-2.42-22.62h6.71l1.3,12.9l5.99-12.9h6.25
        l1.15,13.09l6.08-13.09H337.01z"/>
      <path class="color2" d="M335.19,162.69l2.62-5.62c2.25,1.45,4.55,2.1,6.8,2.1c1.76,0,2.68-0.52,2.68-1.33c0-2.39-9.59-1-9.59-8.01
        c0-5.14,3.83-8.5,10.19-8.5c3,0,5.67,0.68,7.55,1.94l-2.45,5.56c-1.61-1.13-3.57-1.68-5.53-1.68c-1.99,0-2.97,0.74-2.97,1.52
        c0,2.49,9.62,0.9,9.62,7.89c0,5.04-3.92,8.43-10.2,8.43C340.32,164.98,337.12,164.02,335.19,162.69z"/>
    </g>
  `;

  const height = hasBottom? '172.01' : '130';

  const theSvg = `
    <svg viewBox="0 0 402.46 ${height}" xmlns="http://www.w3.org/2000/svg" role="img" aria-label="Logo">
    <style type="text/css">
      .color1{fill:${color2};}
      .color2{fill:${color1}}
    </style>
    <g>
      <g>
        <path class="color2" d="M224.98,75.28c-1.76,26.63-18.76,45.94-40.74,45.87c-17.23-0.06-25.81-12.41-24.77-28.21
          c1.67-25.4,18.36-46.05,41.17-45.97C218.31,47.03,225.95,60.5,224.98,75.28z M181.71,92.52c-0.4,6.04,1.38,10.72,6.54,10.74
          c8.41,0.03,13.83-17.67,14.56-28.73c0.34-5.22-1.27-9.63-6.41-9.65C187.82,64.84,182.28,82.9,181.71,92.52z"/>
        <path class="color2" d="M217.88,119.8l11.36-47.45c2.2-8.9,3.79-17.02,5.24-23.8l18.99,0.06l-1.55,10.15l0.27,0
          c6.18-7.98,13.71-11.58,21.66-11.55c11.31,0.04,15.29,7.91,14.59,18.49c-0.23,3.52-1.18,8.91-2.09,12.82l-9.98,41.48l-21.77-0.07
          l9.6-40.1c0.55-2.32,0.98-4.81,1.14-7.2c0.25-3.73-0.71-6.37-4.02-6.38c-4.74-0.02-10.42,6.81-13.91,21.34l-7.74,32.3
          L217.88,119.8z"/>
        <path class="color2" d="M327.2,28.88l-4.71,19.95l12.93,0.04l-4.24,17.58l-12.99-0.04l-5.64,22.69c-0.55,2.19-1.17,5.29-1.28,7.06
          c-0.24,3.64,1.18,5.78,4.94,5.79c1.41,0,3.34,0.01,5.15-0.2l-4.01,18.29c-2.98,1.08-8.02,1.51-12.24,1.5
          c-12-0.04-17.45-6.56-16.8-16.46c0.24-3.71,0.89-7.6,2.09-12.33l6.44-26.42l-7.8-0.03l4.17-17.58l7.86,0.03l3.48-14.42
          L327.2,28.88z"/>
        <path class="color2" d="M359.38,120.26c0.47-4,0.93-7.99,1.33-11.99l-0.39,0c-5.94,9.91-13.8,13.41-20.24,13.39
          c-11.35-0.04-18.01-9.85-17.05-24.38c1.52-23.04,15.8-49.87,48.19-49.76c8.14,0.03,16.53,1.81,21.89,3.79l-9.54,37.88
          c-1.9,7.75-4.2,22.31-4.64,31.13L359.38,120.26z M367.89,65.66c-1.38-0.29-2.85-0.44-3.86-0.45
          c-10.21-0.03-17.76,17.67-18.41,27.45c-0.4,6.14,1.35,9.89,5.27,9.9c4.01,0.01,9.12-4.79,12.82-20.29L367.89,65.66z"/>
      </g>
      <g>
        <path class="color2" d="M32.3,17.17c7.47-1.49,16.17-2.25,25.21-2.25c13.73,0,24.18,3.51,31.59,10.32c7.88,7.49,12.1,17.94,12.1,32.42
          c0,22.71-9.14,40.93-20.1,50.18c-10.15,8.66-22.43,12.41-41.71,12.41c-10.63,0-20.4-1.1-24.69-2.24L32.3,17.17z M41.01,99.1
          c1.43,0.24,3.5,0.46,6.54,0.46c8.05,0,16.42-4.5,21.23-12.46c4.88-8.17,7.66-17.8,7.66-30.14c0-13.17-6.37-21.89-18.38-21.89
          c-2.68,0-4.47,0.16-5.77,0.47L41.01,99.1z"/>
        <path class="color2" d="M111.6,17.49c6.44-1.64,16.12-2.58,24.93-2.58c7.77,0,18.08,1.15,25.33,7.1c6.39,4.86,10.09,12.81,10.09,22.02
          c0,14.29-6.03,24.67-13.51,30.88c-7.6,6.35-18.4,9.3-29.2,9.3c-2.62,0-4.93-0.32-6.5-0.41l-6.29,35.81H93.87L111.6,17.49z
          M126.29,63.26c1.44,0.24,3.11,0.49,5.74,0.49c11.05,0,16.69-9.23,16.69-17.6c0-8.05-4.99-11.08-11.24-11.08
          c-2.89,0-5.05,0.16-6.34,0.47L126.29,63.26z"/>
      </g>
      {${hasBottom ? bottom : ''}}
      <path class="color1" d="M116.31,4.04L99.38,4c-5.08-0.01-9.87,3.93-10.94,9L82.5,36.8c-0.59,2.8,1.06,5.26,3.78,5.65
        c3.32,0.48,4.89,3.96,3.23,7.17L77.94,71.98c-1.09,2.1,0.14,4.34,2.38,4.34c0.96,0,1.92-0.42,2.64-1.16l28.67-29.26
        c2.55-2.6,4.77-5.52,6.33-8.72c1.13-2.32,1.98-4.74,2.5-7.2l3.95-15.64C125.6,8.78,121.89,4.05,116.31,4.04z"/>
    </g>
    </svg>
  `

  return (
    <Box
      w="100%"
      h="auto"
      dangerouslySetInnerHTML={{ __html: theSvg }}
    />
  )
}
